<script setup lang="ts">
import type { IProps, IEmits } from './career-teamMemberDrawer.types'

const contentMaxHeight = ref<number>(0)
const content = ref<HTMLElement | null>(null)

const { isOpen } = defineProps<IProps>()
const emit = defineEmits<IEmits>()

const onOpenDrawerClick = () => {
  emit('clicked')
}

const calculateTruncation = () => {
  if (!content.value) return
  content.value.style.maxHeight = `${isOpen ? contentMaxHeight.value : '0'}px`
}

onMounted(() => {
  const contentHeight = content?.value?.clientHeight
  contentMaxHeight.value = contentHeight!
  calculateTruncation()
})

watch(() => isOpen, () => {
  calculateTruncation()
})

</script>

<template>
  <div
    class="SingleDrawer"
    @click.stop="onOpenDrawerClick"
  >
    <div class="SingleDrawer__header">
      <p :class="['SingleDrawer__headerText', `${isOpen ? `SingleDrawer__headerText--open${version}` : ''}`]">
        {{ header }}
      </p>

      <div class="SingleDrawer__headerIcon">
        <div class="SingleDrawer__headerIconLine" />

        <div
          v-if="!isOpen"
          class="SingleDrawer__headerIconLine SingleDrawer__headerIconLine--vertical"
        />
      </div>
    </div>

    <div
      ref="content"
      :class="['SingleDrawer__descriptionWrapper', isOpen ? 'SingleDrawer__descriptionWrapper--open' : '']"
    >
      <div class="SingleDrawer__descriptionLine" />

      <p class="SingleDrawer__description">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.SingleDrawer {
  width: 100%;
  margin-bottom: 0.8rem;
  padding: 1.6rem 1.6rem 1.6rem 2.4rem;
  background-color: $white;
  border-radius: 0.8rem;
  cursor: pointer;
  
  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__headerText {
    @include h10;
    max-width: calc(100% - 3.2rem);
    color: $text-400;

    &--opensecondary {
      color: $purple-400;
    }
  }

  &__headerIcon {
    position: relative;
    width: 3.2rem;
    height: 3.2rem;
    border: 2px solid $gray-400;
    border-radius: 50%;
  }

  &__headerIconLine {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1.1rem;
    height: 0.2em;
    background-color: $gray-400;
    transform: translate(-50%, -50%);

    &--vertical {
      width: 0.2rem;
      height: 1.1em;
    }
  }

  &__descriptionWrapper {
    overflow: hidden;
    transition: 0.5s;
  }

  &__descriptionLine {
    width: 100%;
    height: 1px;
    margin-top: 1.6rem;
    background-color: $gray-300;
    
  }

  &__description {
    @include body-2-medium;
    margin: 1.6rem 0 0 0;
    padding: 0 4.1rem 1.6rem 0;
    color: $text-300;
  }
}

@include atM {
  .SingleDrawer {
    &__headerText {
      @include h9;

      &--openprimary {
        @include h7;
      }
      &--opensecondary {
        @include h9;
        color: $purple-400;
      }
    }
  }
}
</style>
